/* eslint-disable react-hooks/exhaustive-deps */
import { useMemo, useState } from 'react';
import { TabItemProps } from '@consumidor-positivo/aurora';
import isMobile from '@libs/utils/helpers/isMobile';

import { OfferCard } from '../../../../components/OfferCard';
import { SHOffer } from '../../../../services/sortingHat';

import { OfferListTabProps } from '.';

export function useOfferListTab(props: OfferListTabProps) {
  const { offerForBenefits, OffersMiddleAd, location, user, initalBenefitTab } = props;

  const [benefitsTabs, setBenefitsTabs] = useState<TabItemProps[]>([]);
  const adsCard = (index: number) => {
    if (!isMobile()) return;
    if (index !== 3) return;
    if (!Boolean(OffersMiddleAd)) return;
    return <OffersMiddleAd />;
  };

  useMemo(() => {
    const tabsWithOffers = offerForBenefits?.filter((filter) => filter?.list?.length > 0);
    const updatedTabs: TabItemProps[] = tabsWithOffers?.map(({ list, ...tabs }) => {
      return {
        ...tabs,
        children: (
          <div className="offer-list-tab__container">
            {list?.map((item: SHOffer, index: number) => {
              return (
                <>
                  <OfferCard key={`offer-list-tab-benefits-filter-${index}`} offer={item} index={index} location={location} user={user} />
                  {adsCard(index)}
                </>
              );
            })}
          </div>
        ),
      };
    });

    setBenefitsTabs(updatedTabs);
  }, [offerForBenefits, initalBenefitTab]);

  return {
    benefitsTabs,
    adsCard,
  };
}
